import React, { useCallback, useEffect, useState, forwardRef } from "react";
import PropTypes from "prop-types";
import cn from "classnames";
import styles from "./SideBar.module.scss";
import Icon from "../Icon";

const SideBar = forwardRef(({ menu, isOpened, handleClose, handleLinkClick, mainLogo, children }, ref) => {
  const [navigationList, setNavigationList] = useState([]);
  const [nextNavigationList, setNextNavigationList] = useState([]);

  const handleItemClick = useCallback(
    (e, item, itemList) => {
      if (item.menu) {
        if (item.isFirstItem) {
          setNavigationList(item.isLastLevel ? nextNavigationList : menu);
        } else {
          setNextNavigationList(itemList);
          setNavigationList([
            {
              id: item.id,
              title: item.title,
              menu: item.menu,
              isFirstItem: true,
              isLastLevel: itemList[0].isFirstItem
            },
            ...item.menu
          ]);
        }
      } else {
        handleLinkClick(e, item.url, item.target, item.isInternalLink);
        handleClose();
      }
    },
    [handleLinkClick, handleClose, nextNavigationList, navigationList]
  );

  useEffect(() => {
    setNavigationList(menu);
  }, [isOpened, menu]);

  return (
    <div className={cn(styles.sideBar, { [styles.opened]: isOpened })} ref={ref}>
      <div className={styles.header}>
        <Icon
          icon="close"
          onClick={() => {
            handleClose();
            setNavigationList(menu);
          }}
          className={styles.close}
        />
        <img className={styles.logo} src={mainLogo.src} title={mainLogo.title || ""} alt={mainLogo.title || ""} />
        {children}
      </div>
      <div className={cn(styles.container, { [styles.navigation]: !isOpened })}>
        {navigationList.map(item => (
          <div
            key={item.id + item.title}
            className={styles.itemsWrap}
            role="button"
            tabIndex="0"
            onClick={e => handleItemClick(e, item, navigationList)}
          >
            {item?.isFirstItem && <Icon icon="header-arrow-icon" className={cn(styles.arrow, styles.arrowLeft)} />}
            <span
              className={cn({
                [styles.title]: !item?.isFirstItem && !item?.isLastLevel && menu.length !== navigationList.length
              })}
            >
              {item.title}
            </span>
            {!!item.menu && !item?.isFirstItem && <Icon icon="header-arrow-icon" className={styles.arrow} />}
          </div>
        ))}
      </div>
    </div>
  );
});

SideBar.propTypes = {
  menu: PropTypes.array.isRequired,
  isOpened: PropTypes.bool.isRequired,
  handleClose: PropTypes.func.isRequired,
  mainLogo: PropTypes.object.isRequired,
  children: PropTypes.node,
  handleLinkClick: PropTypes.func.isRequired
};

SideBar.defaultProps = {
  children: null
};

export default SideBar;
